import React, {useState} from 'react';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';


const industries = [
  'Banking & Financial Services',
  'Healthcare',
  'Manufacturing',
  'Retail',
  'Telecommunications',
  'Energy & Utilities',
  'Technology',
  'Other'
];

const countries = [
  'United States',
  'United Kingdom',
  'India',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Other'
];


const Background = styled(Box) (({ theme }) => ({
  backgroundImage: 'url(https://t3.ftcdn.net/jpg/05/30/96/04/240_F_530960431_c8fPd3HansYvrSJ4fJxZqp9OhjQmYoll.jpg)', // Replace with actual image path
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '60vh',
  display: "flex",
}));

const ContactPage = () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '',
    jobTitle: '',
    country: '',
    industry: '',
    message: '',
    agreeToPolicy: false,
    receiveUpdates: false,
  });

  const [errors, setErrors] = useState({
    email: false,
    contactNo: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (phone) => {
    const re = /^[0-9\-\+\s\(\)]{10,15}$/;
    return re.test(phone);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setErrors(prev => ({ ...prev, email: !validateEmail(value) }));
    } else if (name === 'contactNo') {
      setErrors(prev => ({ ...prev, contactNo: !validatePhone(value) }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here
    console.log('Form submitted:', formData);
    // You would typically send this data to your backend
  };

  return (
    <Box sx={{ pb: 4 }}>
      <Background>
        <Typography variant="h2" sx={{fontWeight: 'bold', alignContent: "center", paddingLeft: "50px",textShadow: '2px 2px 4px rgba(0,0,0,0.5)',fontSize: { xs: '2.5rem', sm: '3rem', md: '5.5rem', width: '100%', px: 2
        }}}>
          Contact us
        </Typography>
      </Background>
      
      <Box display="flex" justifyContent="center" margin="20px" >
        <Typography variant='body2' sx={{maxWidth: "1200px", textAlign: "center", color:"#000", fontSize: { xs: '1rem', md: '1.2rem'}, lineHeight: '1.6', px: { xs: 2, sm: 0 } }}>
            Thank you for your interest in <strong>Willovate Private Limited </strong>  services.Please provide the following information about your business needs to help us serve you better.
            This information will enable us to route your request to the appropriate person. You should receive a response within 48 hours.
        </Typography>
      </Box>

      <Container 
        maxWidth="md"
        sx={{
          mt: 6,
          mb: 6
        }}
      >
        <Box
          sx={{
            backgroundColor: '#c1ddfe',
            p: 4,
            borderRadius: 2,
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
          >
          <Typography 
            variant="h4" 
            component="h1"
             height="7vh"
            sx={{ 
              mb: 4, 
              color: "#012c7c", 
              fontWeight: 'bold', textAlign: "center", alignContent: "center", borderRadius: 2, width: "100%",
            }}
          >
            Contact Us
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Grid >
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px"}}
                  required
                />
              </Grid>
            </Grid>

            <Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}
                  required
                />
              </Grid>
            </Grid>

            <Grid >
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  error={errors.email}
                  helperText={errors.email ? 'Please enter a valid email address' : ''}
                  sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}
                  required
                />
              </Grid>
            </Grid>

            <Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Contact Number"
                  name="contactNo"
                  value={formData.contactNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  error={errors.contactNo}
                  helperText={errors.contactNo ? 'Please enter a valid phone number' : ''}
                  sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}
                  required
                />
              </Grid>
            </Grid>

            <TextField
              fullWidth
              label="Job Title"
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleChange}
              variant="outlined"
              sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}
              required
            />

            <Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" sx={{ mb: 3, width: "100%", maxWidth: "800px", backgroundColor: "#fff", borderRadius: "10px" }}>
                  <InputLabel>Country</InputLabel>
                  <Select
                    label="Country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value=""><em>Select Country</em></MenuItem>
                    {countries.map((country) => (
                      <MenuItem key={country} value={country}>{country}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined" sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}>
                  <InputLabel>Industry</InputLabel>
                  <Select
                    label="Industry"
                    name="industry"
                    value={formData.industry}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem  value=""><em>Select Industry</em></MenuItem>
                    {industries.map((industry) => (
                      <MenuItem key={industry} value={industry}>{industry}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <TextField
              fullWidth
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={4}
              sx={{ mb: 3, backgroundColor: "#fff", borderRadius: "10px" }}
            />

            <Box sx={{ mt: 1, justifyContent: "center", width: "100%" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="agreeToPolicy"
                    checked={formData.agreeToPolicy}
                    onChange={handleChange}
                    color="primary"
                    required
                  />
                }
                label="I confirm, I have read and agree to Willovate Private Limited's  Privacy Policy and consent to sharing my information."
                sx={{ fontSize: '0.9rem', color: "#000" }}
              />
            </Box>

            <Box sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="receiveUpdates"
                    checked={formData.receiveUpdates}
                    onChange={handleChange}
                    color="primary"
                  />
                }
                label="I would like to receive alerts and updates from Willovate Private Limited's.."
                sx={{ fontSize: '0.9rem', color: "#000" }}
              />
            </Box>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                py: 1.5,
                mt: 2,
                fontSize: '1rem',
                borderRadius: "10px"
              }}
              disabled={!formData.agreeToPolicy}
            >
              Submit
            </Button>
          </form>
        </Box>
      </Container>

      
    </Box>
  );
};

export default ContactPage;
